import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=85b1b0a2&scoped=true&"
import script from "./currency.vue?vue&type=script&lang=js&"
export * from "./currency.vue?vue&type=script&lang=js&"
import style0 from "./currency.vue?vue&type=style&index=0&id=85b1b0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1b0a2",
  null
  
)

export default component.exports